export interface Address {
  id?: number;
  customer_id?: number;
  address_type: AddressType;
  salutation?: CustomerSalutation;
  title?: CustomerTitle;
  name?: string;
  surname?: string;
  typename?: string; // Company or association name
  street?: string;
  street_nr?: string;
  street_extra?: string;
  zipcode?: string;
  city?: string;
  country?: string;
  // Note: is_default can be determined by address_type === 'default'
}

export type AddressType = 'default' | 'invoice' | 'delivery' | 'other';
export const AddressTypeMapper: Record<AddressType, string> = {
  default: 'Standard',
  invoice: 'Rechnungsadresse',
  delivery: 'Lieferadresse',
  other: 'Anderes',
};

export type CustomerSalutation = 'mr' | 'mrs' | 'other' | 'none';
export const CustomerSalutationMapper: Record<CustomerSalutation, string> = {
  mr: 'Herr',
  mrs: 'Frau',
  other: 'Divers',
  none: 'Keine Angabe',
};

export type CustomerTitle =
  | 'dr'
  | 'prof'
  | 'profdr'
  | 'dipl'
  | 'mag'
  | 'diplkfm';
export const CustomerTitleMapper: Record<CustomerTitle, string> = {
  dr: 'Dr.',
  prof: 'Prof.',
  profdr: 'Prof. Dr.',
  dipl: 'Dipl.-Ing.',
  mag: 'Mag.',
  diplkfm: 'Dipl.-Kfm.',
};
